import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ConfirmIcon from '../../../icons/confirmIcon'
import WarningIcon from '../../../icons/warningIcon'
import { SxProps, Theme } from '@mui/material'

interface Props {
  title?: string
  type?: 'confirm' | 'warning'
  content?: React.ReactNode
  actions?: React.ReactNode
  sx?: SxProps<Theme> 
}

const icons = {
  confirm: <ConfirmIcon />,
  warning: <WarningIcon />,
}

export default function BodyModalWithActions({ title, type, content, actions, sx }: Props) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex', 
        flexDirection: 'column',
        ...sx
      }}
    >
      {(title || type) && (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          gap: '16px', 
          mb: '16px',
        }}>
          {type && (
            <Box>
              {icons[type]}
            </Box>
          )}
          {title && (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center',
              width: '100%'
            }}>
              <Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                {title}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <Box sx={{ 
        flex: 1, 
        overflow: 'auto',
        mb: '16px',
      }}>
        {content}
      </Box>
      
      {actions && (
        <Box
          sx={{
            borderTop: '1px solid #e0e0e0',
            padding: {
              xs: '16px',
              sm: '20px', 
              md: '24px',
            },
            marginTop: '16px',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            gap: {
              xs: '12px',
              sm: '16px',
              md: '20px',
            },
          }}
        >
          {actions}
        </Box>
      )}
    </Box>
  )
}
